var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7094 5.31254H6.02084C5.62963 5.31254 5.31251 4.99541 5.31251 4.60421C5.31251 4.213 5.62963 3.89587 6.02084 3.89587H12.3958C12.3986 3.89587 12.4013 3.8959 12.4041 3.89593C12.5839 3.89373 12.7644 3.96124 12.9016 4.09845C13.0387 4.23551 13.1062 4.4158 13.1041 4.59543C13.1041 4.59835 13.1042 4.60128 13.1042 4.60421V10.9792C13.1042 11.3704 12.7871 11.6875 12.3958 11.6875C12.0046 11.6875 11.6875 11.3704 11.6875 10.9792V6.29066L5.07654 12.9016C4.80647 13.1717 4.36851 13.1717 4.09843 12.9016C3.82831 12.6315 3.82831 12.1936 4.09843 11.9235L10.7094 5.31254Z",
    fill: "#009C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowGreen);
export default __webpack_public_path__ + "static/media/up-arrow-green.76ad1c697f7892beec75ba78cd464861.svg";
export { ForwardRef as ReactComponent };